<template>
  <div
    id="app"
    class="min-h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>

    <agora-call v-if="user && showAgoraCall" />

    <ai-voice-call />

    <agora-video-call
      v-if="user && showAgoraVideoCall"
      :nudity-check-interval-in-secs="nudityCheckIntervalInSecs"
    />

    <payment
      v-if="paymentStatus && paymentHtml"
      :payment-data="paymentHtml"
    />

    <payment-craftgate
      v-if="paymentStatus && paymentCraftgate"
      :payment-data="paymentCraftgate"
    />

    <b-modal
      v-model="modalDownloadMobileApp"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="lg"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="closeModal"
      >
        {{ $t('Close') }}
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column p-3">
        <div
          class="fs-22 fw-600 text-center color-black"
          v-html="$t('modalDownloadMobileAppTitle')"
        />
        <div class="fs-14 color-gray-2 text-center fw-300 mt-1">
          {{ $t('This user does not accept calls over the telephone line. You can use our mobile apps to search for this user.') }}.
        </div>
        <div class="fs-12 color-gray-2 fw-700 text-center mt-2">
          {{ $t('Download by scanning the QR code') }}
        </div>
        <b-img
          :src="qrCodeImage"
          width="160"
          class="mt-1"
        />
        <div class="fs-12 color-gray-2 fw-700 mt-1">
          {{ $t('Or') }}
        </div>
        <div class="d-flex justify-content-between mt-1 align-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.arasana.arasana&hl=tr&gl=US&pli=1"
            target="_blank"
          >
            <b-img
              :src="badgeGooglePlay"
              height="80"
            />
          </a>
          <a
            href="https://apps.apple.com/app/boho-live-video-chat-talk-meet/id1264652539"
            target="_blank"
          >
            <b-img
              :src="badgeAppleStore"
              height="62"
              class="ml-3"
              style="margin-top: 8px"
            />
          </a>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-if="microphoneAllowedResult && ((modalCallType === 'video' && microphoneAllowed) || modalCallType === 'audio') && false"
      v-model="modalCall"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalCall = false"
      >
        {{ $t('Close') }}
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column p-2">
        <div class="fs-16 fw-700 text-center color-black mb-1">
          {{ $t('Are you sure you want to call {name} user?', {name: modalCallUser ? modalCallUser.userName : ''}) }}
        </div>
        <div class="fw-16 fw-400 color-gray-2">
          <span v-if="modalCallUser && (modalCallUser.profile.callType == 2 || modalCallUser.profile.callType == 0) && microphoneAllowed">
            {{ $t('Call user notification text via Agora') }}
          </span>
          <span v-else>
            {{ $t('Call user notification text') }}
          </span>
        </div>
        <b-button
          variant="primary"
          size="sm"
          class="mt-1"
          block
          :disabled="loading"
          @click="call"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ $t('Call') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="modalCallSuggestion"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalCallSuggestion = false"
      >
        {{ $t('Close') }}
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column p-2">
        <div class="fs-16 fw-600 text-center color-black">
          {{ $t('Do you want to search for the user you like?') }}
        </div>
        <b-button
          variant="primary"
          size="sm"
          class="mt-1"
          block
          :disabled="loading"
          @click="callRequest"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ $t('Call') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="modalAddPhoneNumber"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalAddPhoneNumber = false"
      >
        {{ $t('Close') }}
      </div>
      <b-row>
        <b-col md="12">
          <!--          <div v-if="modalAddPhoneNumberShowDiamond"-->
          <div
            v-if="authType === 'email'"
            class="d-flex justify-content-center align-items-center flex-column pt-3 pl-3 pr-3"
          >
            <b-img
              :src="iconDiamond2"
              width="140"
              class="mb-05"
            />
            <h5
              class="fs-22 fw-600 text-center color-black mb-1"
              v-html="$t('Add phone earn {amount} diamonds', {amount: '300'})"
            />
            <p class="fs-16 fw-300 text-center mb-1 color-gray">
              {{ $t('By registering your phone number, you can win {amount} diamonds and make free calls.', {amount: '300'}) }}
            </p>
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center flex-column pt-3 pl-3 pr-3"
          >
            <h5 class="fs-22 fw-600 text-center color-black mb-1">
              {{ $t('Contact Information') }}
            </h5>
            <p class="fs-16 fw-300 text-center mb-1 color-gray">
              {{ $t('To make and receive calls, you need to fill in your contact information.') }}
            </p>
          </div>
        </b-col>
        <b-col
          md="12"
          class="p-3"
        >
          <!-- form -->
          <validation-observer
            ref="phoneForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form"
              @submit.prevent="phoneNumberVerificationCode"
            >
              <b-form-group label-for="login-phone">
                <validation-provider
                  #default="{ errors }"
                  name="Cep telefonu numarası"
                  vid="phone"
                  rules="required"
                >
                  <vue-tel-input
                    v-model="phone"
                    mode="auto"
                    :input-options="{placeholder: $t('Mobile phone number')}"
                    valid-characters-only
                    :style-classes="['phone-input']"
                    @open="onDropdownOpen(true)"
                    @close="onDropdownOpen(false)"
                    @country-changed="countryChanged"
                    @validate="phoneValidate"
                  >
                    <template v-slot:arrow-icon>
                      <span class="font-small-3 mr-05">
                        {{ country ? '+' + country.dialCode : '' }}
                      </span>
                      <font-awesome-icon
                        v-if="open"
                        icon="fa-solid fa-chevron-up"
                      />
                      <font-awesome-icon
                        v-else
                        icon="fa-solid fa-chevron-down"
                      />
                    </template>
                  </vue-tel-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                class="mt-2"
                type="submit"
                variant="primary"
                block
                :disabled="loading || invalid"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                {{ $t('Continue') }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-if="false"
      v-model="modalAddEmail"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalAddEmail = false"
      >
        {{ $t('Close') }}
      </div>
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-center align-items-center flex-column pt-3 pl-3 pr-3">
            <h5 class="fs-22 fw-600 text-center color-black mb-1">
              {{ $t('Contact Information') }}
            </h5>
            <p class="fs-16 fw-300 text-center mb-1 color-gray">
              {{ $t('You must complete your contact information so that we can provide you with a better service') }}
            </p>
          </div>
        </b-col>
        <b-col
          md="12"
          class="p-3"
        >
          <!-- form -->
          <validation-observer
            ref="emailForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form"
              @submit.prevent="emailUpdateVerification"
            >
              <b-form-group
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Email')"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="email"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Email')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                class="mt-2"
                type="submit"
                variant="primary"
                block
                :disabled="loading || invalid"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                {{ $t('Continue') }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="modalPinCode"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fs-12 color-gray cursor-pointer"
        @click="modalPinCode = false"
      >
        {{ $t('Close') }}
      </div>
      <b-row class="password-information">
        <b-col md="12">
          <div class="d-flex justify-content-center align-items-center flex-column pt-3 pl-3 pr-3">
            <h5 class="fs-22 fw-600 text-center color-black mb-1">
              {{ $t('PIN Code') }}
            </h5>
          </div>
        </b-col>
        <b-col
          sm="12"
          class="mt-2"
        >
          <div class="d-flex justify-content-center">
            <validation-provider
              #default="{ errors }"
              :name="$t('Password')"
              vid="password"
            >
              <PincodeInput v-model="password" />
              <br>
              <div class="text-danger text-center mt-2">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </b-col>

        <b-col sm="12">
          <p class="send-again">
            {{ $t('Code not received?') }}
            <span
              class="link"
              @click="sendAgainPinCode"
            >
              {{ $t('Send again') }}
            </span>
          </p>
        </b-col>
        <b-col md="12">
          <b-button
            class="mt-2 mb-1"
            type="submit"
            variant="primary"
            block
            :disabled="loading"
            @click="verification"
          >
            <b-spinner
              v-if="loading"
              small
            />
            {{ $t('Approve') }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="modalDownloadApp"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <div
        class="d-flex justify-content-end fw-600 fs-16 color-gray cursor-pointer"
        @click="modalDownloadApp = false"
      >
        x
      </div>
      <b-row class="password-information">
        <b-col md="12">
          <div class="d-flex justify-content-center align-items-center flex-column pt-2 pl-2 pr-2">
            <h6 class="fs-16 fw-600 text-center color-black mb-1">
              {{ streamStartedNotification }}
            </h6>
          </div>
          <div class="d-flex justify-content-center align-items-center flex-column pt-2 pl-5 pr-5">
            <h4 class="fs-22 fw-600 text-center color-black mb-1">
              {{ $t('Download our mobile app to watch the stream') }}
            </h4>
          </div>
        </b-col>
        <b-col
          sm="12"
          class="mt-2"
        >
          <div class="d-flex flex-column gap-12 mb-2 justify-content-center">
            <b-button
              variant="outline-secondary"
              href="https://play.google.com/store/apps/details?id=com.arasana.arasana"
              target="_blank"
            >
              <b-img
                :src="badgeGooglePlay2"
                height="36"
                style="margin-top: 8px"
              />
            </b-button>
            <b-button
              variant="outline-secondary"
              href="https://apps.apple.com/app/boho-live-video-chat-talk-meet/id1264652539"
              target="_blank"
            >
              <b-img
                :src="badgeAppleStore2"
                height="36"
                style="margin-top: 8px"
              />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="oopsModal"
      centered
      hide-header-close
      hide-footer
      hide-header
      body-class="credits-oops"
      size="md"
    >
      <div class="credits-oops-image">
        <b-img
          :src="imageCreditsOops"
          style="width: 100%;"
        />
        <div class="credit-oops-image-text">
          {{ $t('Oops') }}!
          <b-img :src="imageCreditsOopsSadFace" />
        </div>
      </div>
      <div class="credits-oops-text">
        <h3>
          {{ oopsModalText }}
        </h3>
      </div>
    </b-modal>

    <b-modal
      v-model="modalIdle"
      centered
      hide-header-close
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <h3 class="color-black">
        {{ $t('Are you here?') }}
      </h3>
      <div>
        <p>
          {{ $t('Click to stay active and continue receiving calls') }}
        </p>
        <div class="text-right">
          <b-button
            variant="success"
            size="sm"
            @click="modalIdle = false"
          >
            {{ $t('I\'m here') }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <div v-if="!['buy', 'payment.finalize', 'video-room', 'video-room-setup', 'voice-room', 'voice-room-setup'].includes($route.name)">
      <b-modal
        v-if="showModalData"
        v-model="modalMessageCompleted"
        centered
        hide-header-close
        hide-footer
        hide-header
        size="md"
      >
        <div
          class="d-flex justify-content-end fs-12 color-gray cursor-pointer fw-700"
          @click="modalMessageCompleted = false"
        >
          x
        </div>
        <b-row class="password-information">
          <b-col md="12">
            <div class="d-flex justify-content-center align-items-center flex-column pt-1 pl-3 pr-3">
              <h5 class="fs-22 fw-600 text-center color-black mb-05">
                {{ showModalData.title }}
              </h5>
              <p
                class="fs-20 text-center fw-600 mb-1"
                style="color: #7a00a6"
              >
                {{ showModalData.desc }}
              </p>
              <b-avatar
                v-if="showModalData.avatar"
                size="96"
                :src="showModalData.avatar"
              />
              <p class="fs-20 text-center color-black mt-1">
                {{ showModalData.content }}
              </p>
            </div>
          </b-col>
          <b-col
            v-if="showModalData.products"
            md="12"
          >
            <router-link :to="{name: 'buy', params: { productId: showModalData.products, purchaseSource: 'web_message_completed' }}">
              <b-button
                class="mt-2 mb-1 btn-primary2"
                type="submit"
                variant="primary"
                block
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                {{ showModalData.button_text }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        v-if="showModalData"
        v-model="modalNdcMessageFlow"
        centered
        hide-header-close
        hide-footer
        hide-header
        size="md"
      >
        <div
          class="d-flex justify-content-end fs-12 color-gray cursor-pointer fw-700"
          @click="modalNdcMessageFlow = false"
        >
          x
        </div>
        <b-row class="password-information">
          <b-col md="12">
            <div class="d-flex justify-content-center align-items-center flex-column pt-1 pl-3 pr-3">
              <h5 class="fs-22 fw-600 text-center color-black mb-1">
                {{ showModalData.title }}
              </h5>
              <b-avatar
                v-if="showModalData.avatar"
                size="96"
                :src="showModalData.avatar"
              />
              <p class="fs-18 text-center color-black fw-600">
                {{ showModalData.user_name }}
              </p>
              <p class="fs-20 text-center color-black">
                {{ showModalData.content }}
              </p>
            </div>
          </b-col>
          <b-col md="12">
            <b-button
              class="mt-2 mb-1 btn-primary2"
              type="submit"
              variant="primary"
              block
              :disabled="loading"
              @click="userTriggeredFreeMessage"
            >
              <b-spinner
                v-if="loading"
                small
              />
              {{ showModalData.button_text }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <paywall-boost-modal
        :profile-image="profileImage"
        :user-name="userName"
        :modal-model="modalBoostFlow"
        :show-modal-data="showModalData"
      />
    </div>

    <div
      v-if="riveStatus"
      id="canvas-rive-container"
    >
      <canvas
        ref="canvasRive"
        width="360"
        height="460"
      />
    </div>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import PincodeInput from 'vue-pincode-input'
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'
import {
  clarityPushUserId, gtmPushUserId, showNotify, throwDefaultError, throwPaymentError, settingsRegister,
} from '@/helpers/helpers'
import { Rive } from '@rive-app/webgl'
import AgoraRTC from 'agora-rtc-sdk-ng'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import {
  BAvatar,
  BButton, BCol, BForm, BFormGroup, BFormInput, BImg, BModal, BRow, BSpinner,
} from 'bootstrap-vue'
import PaywallBoostModal from '@/components/PaywallBoostModal.vue'

import store from '@/store'
import useJwt from '@/auth/jwt/useJwt'
import AgoraCall from '@/components/AgoraCall.vue'
import AgoraVideoCall from '@/components/AgoraVideoCall.vue'
import AiVoiceCall from '@/components/AiVoiceCall.vue'
import Payment from '@/components/Payment.vue'
import { paymentReturnRoute } from '@/views/market/dynamicMarketCheckout'
import PaymentCraftgate from '@/components/PaymentCraftgate.vue'
import io from 'socket.io-client'
import axios from 'axios'

import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { unlockCallSounds } from '@/helpers/callSounds'

const getBrowserType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Mobile cihaz kontrolü
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
      || (window.matchMedia && window.matchMedia('(max-width: 768px)').matches)
      || ('ontouchstart' in window)
      || (navigator.maxTouchPoints > 0)

  return isMobile ? 'mobile' : 'desktop'
}

// PWA kontrolü
const isPWA = () => {
  // Standalone mode kontrolü (PWA olarak yüklenmiş)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true
      // Sayfaya enjekte edilen bir script document.referrer'ı null yapabiliyor
      || (document.referrer || '').includes('android-app://')
      || window.location.href.includes('mode=standalone')

  // iOS PWA kontrolü
  const isIOSPWA = ('standalone' in window.navigator) && window.navigator.standalone

  // Service Worker kontrolü (PWA için gerekli)
  const hasServiceWorker = 'serviceWorker' in navigator

  return isStandalone || isIOSPWA || (hasServiceWorker && isStandalone)
}

try {
  const mixPanelToken = process.env.VUE_MIX_PANEL_TOKEN
  mixpanel.init(mixPanelToken, { autocapture: true })
} catch (e) {
  console.error('Mixpanel init error', e)
}

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
  apiKey: 'AIzaSyA2EBTR2-XiTrjber-m75uhJeDYQIij_sE',
  authDomain: 'arasana-5eec0.firebaseapp.com',
  databaseURL: 'https://arasana-5eec0.firebaseio.com',
  projectId: 'arasana-5eec0',
  storageBucket: 'arasana-5eec0.appspot.com',
  messagingSenderId: '821636087237',
  appId: '1:821636087237:web:d7b1b62bed6920aa0fdfac',
  measurementId: 'G-KD21YW8JPJ',
}

// Initialize Firebase
// eslint-disable-next-line no-unused-vars
const app = initializeApp(firebaseConfig)
// eslint-disable-next-line no-unused-vars
window.firebaseAnalytics = getAnalytics(app)

// import LayoutVertical from '@/layouts/vertical/LayoutVertical.vue'
// import LayoutHorizontal from '@/layouts/horizontal/LayoutHorizontal.vue'
// import LayoutFull from '@/layouts/full/LayoutFull.vue'
const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
// eslint-disable-next-line import/extensions
const LayoutFullContainer = () => import('@/layouts/full/LayoutFullContainer')

const badgeAppleStore = require('@/assets/images/banner/app-store-badge.png')
const badgeAppleStore2 = require('@/assets/images/logo/apple-store.png')
const badgeGooglePlay = require('@/assets/images/banner/google-play-badge.png')
const badgeGooglePlay2 = require('@/assets/images/logo/google-play.png')
const iconDiamond2 = require('@/assets/images/icons/diamonds-2.svg')
const imageCreditsOops = require('@/assets/images/misc/credits-oops.png')
const imageCreditsOopsSadFace = require('@/assets/images/misc/sad-face.png')
const qrCodeImage = require('@/assets/images/banner/mobile-application-qr-code.png')

export default {
  components: {
    BAvatar,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BModal,
    BRow,
    BSpinner,

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    LayoutFullContainer,

    AgoraCall,
    AgoraVideoCall,
    AiVoiceCall,
    Payment,
    PaymentCraftgate,
    PaywallBoostModal,

    PincodeInput,

    ScrollToTop,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      country: null,
      email: '',
      firebaseToken: null,
      inactivityTimer: null,
      inactivityTimeout: 3 * 60 * 1000,
      microphoneAllowed: false,
      microphoneAllowedResult: false,
      modalIdle: false,
      modalIdleId: null,
      modalMessageCompleted: false,
      modalNdcMessageFlow: false,
      modalBoostFlow: false,
      modalObserver: null,
      nudityCheckIntervalInSecs: 5,
      open: false,
      password: '',
      phone: '',
      reconnectCount: 0,
      reconnectAttempts: 5,
      reconnectCountChat: 0,
      reconnectAttemptsChat: 5,
      rive: null,
      riveStatus: false,
      showModalData: null,
      socketDisconnectTimer: null,
      // Giden arama başlatılırken tekrar tetiklenmesini önleyen kilit (bkz. call())
      outgoingCallStarting: false,
      socketDisconnectTimeout: 60 * 1000,
      valid: false,
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    agoraCalling() {
      return this.$store.getters['agora/agoraCalling']
    },
    // Aktif görüşme varsa idle popup gösterilmez
    isInCall() {
      return this.agoraCalling
        || this.showAgoraCall
        || this.showAgoraVideoCall
        || ['video-room', 'video-room-setup', 'voice-room', 'voice-room-setup'].includes(this.$route.name)
    },
    authType() {
      return this.$store.getters['auth/authType']
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    layout() {
      if (this.$route.name === null) return 'layout-full'
      if (this.$route.meta.layout === 'full') return 'layout-full'
      if (this.$route.meta.layout === 'full-container') return 'layout-full-container'
      return `layout-${this.contentLayoutType}`
    },
    modalCall: {
      get() {
        return this.$store.getters['app/modalCall']
      },
      set(value) {
        this.$store.dispatch('app/setModalCall', value)
      },
    },
    modalDownloadApp: {
      get() {
        return this.$store.getters['app/modalDownloadApp']
      },
      set(value) {
        this.$store.dispatch('app/setModalDownloadApp', value)
      },
    },
    streamStartedNotification() {
      return this.$store.getters['app/streamStartedNotification']
    },
    modalCallUser() {
      return this.$store.getters['app/modalCallUser']
    },
    modalCallType() {
      return this.$store.getters['app/modalCallType']
    },
    phoneWithCountryCode() {
      return this.country ? `+${this.country.dialCode}${this.phone.replace(/ /g, '')}` : this.phone.replace(/ /g, '')
    },
    socketConnection() {
      return this.$store.getters['socket/connection']
    },
    userFromStore() {
      return this.$store.getters['auth/user']
    },
    tokenFromStore() {
      return this.$store.getters['auth/token']
    },
    userPhoneNumber2() {
      return this.$store.getters['auth/userPhoneNumber']
    },
    // user: setup() içinde aynı store değeri olarak tanımlı (iki kez tanımlanması Vue uyarısı veriyordu)
    userGender() {
      return this.$store.getters['auth/userGender']
    },
    profileImage() {
      return this.$store.getters['auth/profileImage']
    },
    userName() {
      return this.$store.getters['auth/userName']
    },
    userCanReceiveVideoCall() {
      return this.$store.getters['auth/userCanReceiveVideoCall']
    },
  },
  watch: {
    $route: {
      // eslint-disable-next-line no-unused-vars
      handler(value) {
        // this.$store.dispatch('app/setSearchBar', false)
        this.checkSkin()

        this.showModalData = null
        this.modalMessageCompleted = false
      },
      deep: true,
    },
    modalCall: {
      handler(value) {
        const that = this
        if (value) {
          // eslint-disable-next-line no-underscore-dangle
          let _config = { audio: true }

          if (this.$store.getters['app/modalCallType'] === 'video') {
            _config = { audio: true, video: true }
          }

          navigator.mediaDevices.getUserMedia(_config)
            .then(stream => {
              that.microphoneAllowed = true
              stream.getAudioTracks()[0].stop()
              if (stream.getVideoTracks()[0]) {
                stream.getVideoTracks()[0].stop()
              }

              this.call()
            })
            .catch(() => {
              that.microphoneAllowed = false
              if (store.getters['app/modalCallType'] === 'video') {
                showNotify(that.$toast, that.$t('You must allow microphone and camera'), 'danger')
              } else if (store.getters['app/modalCallType'] === 'audio') { // önceden 'adio' yazımı yüzünden sesli aramada uyarı hiç çıkmıyordu
                showNotify(that.$toast, that.$t('Microphone permission is required for voice calls. Please allow microphone access and try again.'), 'danger')
              }
              // modalCall true kalırsa sonraki arama tıklamaları (true -> true) izleyiciyi tetiklemiyor ve buton çalışmıyordu
              that.modalCall = false
            })
            .finally(() => {
              that.microphoneAllowedResult = true
            })
        }
      },
      deep: true,
    },
    modalIdle(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        // modalIdle true olduğunda - 1 dakika sonra socket kesecek timer başlat
        this.startSocketDisconnectTimer()

        // useJwt checkinPopupData isteği gönder
        useJwt.checkinPopupData()
          .then(response => {
            this.modalIdleId = response.data.body.id
          })
      } else if (oldVal === true && newVal === false) {
        // modalIdle false olduğunda - socket disconnect timer'ını iptal et
        this.clearSocketDisconnectTimer()

        // useJwt checkinPopupDataConfirm isteği gönder
        if (this.modalIdleId) {
          useJwt.checkinPopupDataConfirm({ id: this.modalIdleId })
        }

        // Socket bağlantısını yeniden kur ve inactivity dinlemeyi başlat.
        // Ekran uzun süre kapalı kalınca socket.io yeniden bağlanma beklemesindeydi; düz connect() bu durumda
        // hiçbir şey yapmıyordu ve "Buradayım" sonrası online olunmuyordu. Ana + sohbet socket'i hemen bağlanır.
        this.reconnectSocketsNow()
        if (this.userGender === 'female') {
          this.startInactivityTimer()
          this.addEventListeners()
        }
      }
    },
    isInCall(newVal) {
      if (newVal) {
        // Görüşme başladı - idle timer'ları durdur, açık popup'ı kapat
        this.clearInactivityTimer()
        this.clearSocketDisconnectTimer()
        this.modalIdle = false
      } else if (this.user && this.userGender === 'female') {
        // Görüşme bitti - idle takibine yeniden başla
        this.startInactivityTimer()
      }
    },
    userFromStore(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.openSocket()
      }
    },
    // Kayıt ve çok adımlı girişte kullanıcı önce kaydedilip token sonradan değişiyor; socket ise ilk
    // token ile açılmış kalıyordu. Sunucu bu bağlantıya gelen aramayı iletmediği için arama ancak sayfa
    // yenilenince geliyordu. Kullanıcı zaten varken token değişirse socket'leri yeni token ile yeniden aç.
    tokenFromStore(newValue, oldValue) {
      if (!newValue || newValue === oldValue || !this.userFromStore) return
      if (!this.$store.getters['socket/connection']) return
      this.$store.dispatch('socket/disconnectConnection')
      this.$store.dispatch('socket/disconnectChatConnection')
      this.openSocket()
    },
    user(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        // User varsa ve female ise süreleri başlat
        if (this.userGender === 'female') {
          this.startInactivityTimer()
          this.addEventListeners()
        }
        settingsRegister(this.firebaseToken, null, store.getters['app/deviceId'])
      } else if (!newValue) {
        // User yoksa süreleri iptal et
        this.clearInactivityTimer()
        this.clearSocketDisconnectTimer()
        this.modalIdle = false
      }
    },
    userGender(newValue) {
      if (newValue === 'female' && this.user) {
        // userGender female olduğunda ve user varsa süreleri başlat
        this.startInactivityTimer()
        this.addEventListeners()
      } else if (newValue !== 'female') {
        // userGender female değilse süreleri iptal et
        this.clearInactivityTimer()
        this.clearSocketDisconnectTimer()
        this.modalIdle = false
      }
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')

    // this.$OneSignal
    //   .init({
    //     appId: '24316720-00b1-42f7-a12d-a1339b385ef6',
    //   })
    //   .then(() => {
    //     console.log('111111')
    //     this.$OneSignal.User.PushSubscription.optIn()
    //
    //     console.log('this.$OneSignal.User', this.$OneSignal.User)
    //
    //     this.$OneSignal.Notifications.addEventListener('click', event => {
    //       console.log('The notification was clicked!', event)
    //     })
    //   })
  },
  beforeDestroy() {
    this.removeEventListeners()
    this.clearInactivityTimer()
    this.clearSocketDisconnectTimer()
    document.removeEventListener('visibilitychange', this.onPresenceVisibilityChange)
    window.removeEventListener('pageshow', this.onPresenceVisibilityChange)

    // 3. Component yok edilirken observer'ı temizle (Memory leak önleme)
    if (this.modalObserver) {
      this.modalObserver.disconnect();
    }

    // Event listener'ı temizle
    this.$root.$off('bv::modal::shown');
  },
  created() {
    this.checkSkin()

    localStorage.setItem('showMessage', '1')

    // Default olarak api key ve token'ın silinmesi için
    localStorage.removeItem('api-key')
    if (!this.$store.getters['auth/user']) {
      localStorage.removeItem('accessToken')
    }

    const userId = this.$store.getters['auth/userId']
    if (userId) {
      gtmPushUserId(userId)
      clarityPushUserId(userId)
    }

    if (this.userFromStore) {
      this.openSocket()
    }

    const that = this
    window.addEventListener('message', event => {
      if (event?.data?.type === 'payment.result') {
        that.$store.dispatch('payment/setLoading', false)
        if (event?.data?.data?.type === 'defaultError') {
          throwDefaultError(that.$toast, event.data.data.error)
        } else if (event?.data?.data?.message) {
          showNotify(that.$toast, event.data.data.message, event.data.data.type)
        }

        // if (event?.data?.data?.type === 'success') {
        //   useJwt.getMe()
        //       .then(response => {
        //         try {
        //           that.$store.dispatch('auth/updateUser', response.data.body)
        //           that.$router.push({ name: 'market' })
        //         } catch (e) {
        //           throwDefaultError(that.$toast)
        //         }
        //       })
        //       .catch(error => {
        //         throwDefaultError(that.$toast, error)
        //       })
        // }

        if (event?.data?.data?.transaction) {
          if (event?.data?.data?.transaction?.type === 'posnet') {
            useJwt.paymentPostnetPerform(event?.data?.data?.transaction.data)
              .then(response => {
                const paymentStatus = response.data.body

                if (paymentStatus.approved) {
                  localStorage.removeItem('LAST_PAYMENT_TRANSACTION_ID_KEY')
                  localStorage.removeItem('LAST_PAYMENT_AMOUNT')
                  localStorage.removeItem('LAST_COUPON_CODE')
                  // that.deleteCookie(event?.data?.data?.transaction?.ykbPosInfoFromServerKey)

                  useJwt.getMe()
                    .then(response2 => {
                      that.$store.dispatch('auth/updateUser', response2.data.body)
                    })
                    .catch(error => {
                      throwDefaultError(that.$toast, error)
                    })
                    .finally(() => {
                      showNotify(that.$toast, that.$t('You have successfully purchased product'), 'success')
                      that.$router.push({ name: paymentReturnRoute(that.$route) })
                    })
                } else {
                  showNotify(that.$toast, that.$t('An error occurred during the payment process. Please try again.'), 'danger')
                  that.paymentStatus = false
                }
              })
              .catch(error => {
                throwPaymentError(that.$toast, error)
                // that.$router.push({ name: 'market' })
              })
              .finally(() => {
                that.$store.dispatch('payment/setStatus', false)
                that.$store.dispatch('payment/setLoading', false)
                that.$store.dispatch('payment/setPaymentData', null)
                that.$store.dispatch('payment/setPaymentHtml', null)
              })
          } else if (event?.data?.data?.transaction?.type === 'craftgate') {
            useJwt.paymentCraftgateFinalize({
              token: event?.data?.data?.transaction?.token,
            })
              .then(response => {
                const paymentStatus = response.data.body
                if (paymentStatus === 'success') {
                  localStorage.removeItem('LAST_PAYMENT_TRANSACTION_ID_KEY')
                  localStorage.removeItem('LAST_PAYMENT_AMOUNT')
                  localStorage.removeItem('LAST_COUPON_CODE')
                  // that.deleteCookie(event?.data?.data?.transaction?.ykbPosInfoFromServerKey)

                  useJwt.getMe()
                    .then(response2 => {
                      that.$store.dispatch('auth/updateUser', response2.data.body)
                    })
                    .catch(error => {
                      throwDefaultError(that.$toast, error)
                    })
                    .finally(() => {
                      showNotify(that.$toast, that.$t('You have successfully purchased product'), 'success')
                      that.$router.push({ name: paymentReturnRoute(that.$route) })
                    })
                } else {
                  showNotify(that.$toast, that.$t('An error occurred during the payment process. Please try again.'), 'danger')
                  that.paymentStatus = false
                }
              })
              .catch(error => {
                throwDefaultError(that.$toast, error)
                // that.$router.push({ name: 'market' })
              })
              .finally(() => {
                that.$store.dispatch('payment/setStatus', false)
                that.$store.dispatch('payment/setLoading', false)
                that.$store.dispatch('payment/setPaymentData', null)
                that.$store.dispatch('payment/setPaymentHtml', null)
              })
          }
        }
      }
    })

    this.$store.dispatch('app/setDeviceId')

    this.getFirebaseNotificationToken()
  },
  mounted() {
    // Zil sesi için ses kilidini kullanıcının sitedeki ilk dokunuşunda sessizce aç
    this.setupAudioUnlockOnFirstInteraction()
    // iOS Safari'de karşı tarafın sesi otomatik çalınamazsa bir sonraki dokunuşta yeniden başlat
    this.setupAgoraAutoplayRecovery()
    // Sekme/uygulamaya dönüşte: kopmuş bağlantıyı hemen kur, arka planda 3 dk geçtiyse "Burada mısın?" aç
    this.setupPresenceRecovery()

    // Firebase Analytics Event
    if (window.firebaseAnalytics) {
      logEvent(window.firebaseAnalytics, 'first_visit', {
        browser: getBrowserType(),
        pwa: isPWA(),
      })
    }

    // 1. Gözlemciyi Tanımla
    this.modalObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          // Body'de 'modal-open' sınıfı var mı kontrol et
          const isModalOpen = document.body.classList.contains('modal-open')

          // Tawk.to API'sinin yüklü olup olmadığını kontrol et
          // (Sayfa ilk açıldığında tawk henüz yüklenmemiş olabilir, hata vermesin diye kontrol ediyoruz)
          if (typeof window.Tawk_API !== 'undefined') {
            if (isModalOpen) {
              // Modal AÇIKSA -> Tawk.to'yu Gizle
              console.log('Modal açıldı, Tawk gizleniyor...')
              window.Tawk_API.hideWidget()
            } else {
              // Modal KAPALIYSA -> Tawk.to'yu Göster
              console.log('Modal kapandı, Tawk gösteriliyor...')
              window.Tawk_API.showWidget()
            }
          }
        }
      })
    })

    // 2. Body etiketini izlemeye başla
    this.modalObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'], // Sadece class değişimlerini izle
    })
  },
  methods: {
    // Tarayıcılar kullanıcı etkileşimi olmadan ses çaldırmıyor. Önceden bu kilit arama geldiği anda, tam ekran
    // bir "Sesi Aç" katmanıyla açılıyordu ve katman ilk aramada 1-2 sn butonları tıklanamaz yapıyordu.
    // Artık kullanıcının sitedeki ilk tıklama/dokunuş/tuş basışında görünmeden, bir kez açılıyor.
    setupAudioUnlockOnFirstInteraction() {
      const events = ['pointerdown', 'touchstart', 'keydown']
      const unlock = () => {
        events.forEach(eventName => document.removeEventListener(eventName, unlock, true))
        try {
          const AudioContextClass = window.AudioContext || window.webkitAudioContext
          if (AudioContextClass) {
            // Sessiz, 1 örneklik bir ses çal: Safari/iOS dahil ses motorunu kullanıcı etkileşimiyle başlatır
            const context = new AudioContextClass()
            const source = context.createBufferSource()
            source.buffer = context.createBuffer(1, 1, 22050)
            source.connect(context.destination)
            source.start(0)
            if (context.state === 'suspended' && context.resume) context.resume().catch(() => {})
            setTimeout(() => {
              if (context.close) context.close().catch(() => {})
            }, 1000)
          }
          // Zil seslerinin kendisini de aynı dokunuşta aç: Safari AudioContext kilidini <audio> öğelerine
          // saymıyor. Arama bileşenleri bu bayrağı okuyup zil öncesi ek kilit açma beklemesini atlar,
          // bu yüzden bayrak yalnızca zil sesleri gerçekten açıldıysa yazılır.
          unlockCallSounds().then(unlocked => {
            if (unlocked) localStorage.setItem('audioUnlocked', '1')
            else localStorage.removeItem('audioUnlocked')
          })
        } catch (error) {
          // Ses kilidi açılamasa da site normal çalışır; zil bu durumda çalmayabilir
        }
      }
      events.forEach(eventName => document.addEventListener(eventName, unlock, true))
    },
    // iOS Safari, kullanıcı dokunuşundan bağımsız başlayan sesi engelliyor. Görüşmede karşı tarafın sesi
    // (remoteAudioTrack.play) engellenirse Agora onAutoplayFailed'i tetikler; önceden bu tanımlı değildi ve
    // arama açılıp karşı taraf duyulmuyordu. Kullanıcının bir sonraki dokunuşunda ses görünmeden yeniden başlatılır.
    setupAgoraAutoplayRecovery() {
      const events = ['pointerdown', 'touchstart', 'keydown']
      AgoraRTC.onAutoplayFailed = () => {
        const resume = () => {
          events.forEach(eventName => document.removeEventListener(eventName, resume, true))
          const params = this.$store.getters['agora/agoraChannelParameters'] || {}
          if (params.remoteAudioTrack && typeof params.remoteAudioTrack.play === 'function') {
            try {
              params.remoteAudioTrack.play()
            } catch (error) {
              // Ses yeniden başlatılamazsa görüşme yine devam eder
            }
          }
        }
        events.forEach(eventName => document.addEventListener(eventName, resume, true))
      }
    },
    call() {
      if (this.modalCallUser) {
        if (this.microphoneAllowed) {
          // eslint-disable-next-line eqeqeq
          // Agora araması zaten mevcutsa bilgilendirme göster
          if (this.agoraCalling) {
            showNotify(this.$toast, this.$t('You are already calling'), 'info')
            return
          }
          // Çift tetiklemeyi engelle: ilk aramada mikrofon izni beklenirken hem modalCall izleyicisi hem
          // "Ara" butonu call()'u çağırabiliyordu; arama bileşeni yeniden kurulup ikinci appCall isteği
          // "meşgul" hatası alıyor, karşı tarafta ise ilk istek çalmaya devam ediyordu.
          if (this.outgoingCallStarting) return
          this.outgoingCallStarting = true
          setTimeout(() => {
            this.outgoingCallStarting = false
          }, 3000)
          // Kullanıcı app üzerinden arama kabul ettiği için agora üzerinden arama yap
          // store.dispatch('app/setModalDownloadMobileApp', true)
          this.triggerShowAgoraCall(this.modalCallUser, 'outgoing')
        }
      }
    },
    callRequest() {
      store.dispatch('app/setModalCall', true)
    },
    checkSkin() {
      const currentRoute = this.$route

      if (typeof currentRoute.meta.skin !== 'undefined') {
        this.$store.commit('appConfig/UPDATE_SKIN', currentRoute.meta.skin)
      } else {
        this.$store.commit('appConfig/UPDATE_SKIN', 'light')
      }
    },
    countryChanged(country) {
      this.country = country
    },
    emailUpdateVerification() {
      this.$refs.emailForm.validate().then(success => {
        if (success) {
          this.loading = true
          useJwt.emailUpdateVerification({ email: this.email })
            .then(response => {
              showNotify(this.$toast, response.data.body, 'success')
              this.verificationType = 'email'
              this.modalPinCode = true
              this.modalAddEmail = false
            })
            .catch(error => {
              throwDefaultError(this.$toast, error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getFirebaseNotificationToken() {
      const messaging = getMessaging()
      const userId = this.$store.getters['auth/userId']
      const vapidKey = 'BAphd6cJb9veJXouEONzCH506k4oC6qi0-VK8gjPGsNgEK_97WY-AyDy3E-_bh6I5nhqW_cKt7qLNoq_bpOGaX0'
      const deviceId = this.$store.getters['app/deviceId']

      getToken(messaging, { vapidKey })
        .then(currentToken => {
          if (currentToken) {
            this.firebaseToken = currentToken
          }
        }).catch(() => {})
        .finally(() => {
          if (userId) {
            settingsRegister(this.firebaseToken, null, deviceId)
          }
        })
    },
    onDropdownOpen(open) {
      this.open = open
    },
    refreshUnreadChatCount() {
      if (!this.$store.getters['auth/userId']) return

      useJwt.getChatUsers2(0, 100)
        .then(response => {
          const contacts = response.data.body || []
          const total = contacts.reduce((sum, contact) => sum + (Number(contact.unSeenMsgCount) || 0), 0)
          this.$store.dispatch('socket/setUnreadChatCount', total)
        })
        .catch(() => {})
    },
    async openSocket() {
      // eslint-disable-next-line no-underscore-dangle
      const _chatConnection = await io(process.env.VUE_APP_CHAT_SOCKET_URL,
        {
          reconnection: true, // Otomatik yeniden bağlanmayı aktifleştir
          reconnectionAttempts: 5, // Maksimum deneme sayısı (default: Infinity)
          reconnectionDelay: 10 * 1000, // İlk deneme öncesi bekleme süresi ms (default: 1000)
          reconnectionDelayMax: 30 * 1000, // Maksimum bekleme süresi ms (default: 5000)
          randomizationFactor: 0.5, // Rastgelelik faktörü (default: 0.5)
          query: {
            uuid: this.$store.getters['auth/userId'],
            'x-bpsh-connect-api-key': process.env.VUE_APP_API_KEY,
            'x-bpsh-connect-token': this.$store.getters['auth/token'],
          },
          transports: ['websocket', 'polling', 'flashsocket'],
        })

      await this.$store.dispatch('socket/updateChatConnection', _chatConnection)
      this.refreshUnreadChatCount()

      // eslint-disable-next-line no-underscore-dangle
      const _connection = await io(process.env.VUE_APP_SOCKET_URL,
        {
          reconnection: true, // Otomatik yeniden bağlanmayı aktifleştir
          reconnectionAttempts: 5, // Maksimum deneme sayısı (default: Infinity)
          reconnectionDelay: 10 * 1000, // İlk deneme öncesi bekleme süresi ms (default: 1000)
          reconnectionDelayMax: 30 * 1000, // Maksimum bekleme süresi ms (default: 5000)
          randomizationFactor: 0.5, // Rastgelelik faktörü (default: 0.5)
          query: {
            uuid: this.$store.getters['auth/userId'],
            'x-bpsh-connect-api-key': process.env.VUE_APP_API_KEY,
            'x-bpsh-connect-token': this.$store.getters['auth/token'],
          },
          transports: ['websocket', 'polling', 'flashsocket'],
        })

      await this.$store.dispatch('socket/updateConnection', _connection)
      // await this.$store.dispatch('socket/updateChatConnection', _connection) // TODO: çoklu socket olunca bu satırı sil!!!

      _connection.on('reconnecting', () => {
        this.$store.dispatch('socket/updateConnecting', true)
        this.reconnectCount += 1
        if (this.reconnectCount >= this.reconnectAttempts) {
          _connection.disconnect()
        }
      })
      _chatConnection.on('reconnecting', () => {
        this.$store.dispatch('socket/updateConnecting', true)
        this.reconnectCountChat += 1
        if (this.reconnectCountChat >= this.reconnectAttemptsChat) {
          _chatConnection.disconnect()
        }
      })
      _chatConnection.on('receive', chatMsgDTO => {
        const from = chatMsgDTO?.fromId || chatMsgDTO?.from
        if (from && from !== this.$store.getters['auth/userId'] && this.$route.name !== 'chat') {
          this.$store.dispatch('socket/incrementUnreadChatCount', 1)
        }
      })

      _connection.on('connect', () => {
        this.$store.dispatch('socket/updateConnecting', false)
        this.$store.dispatch('socket/updateConnected', true)
        // Başarılı bağlantıda sayaç sıfırlansın; yoksa oturum boyunca toplam 5 kopma sonrası socket kalıcı kapanıyordu
        this.reconnectCount = 0
        // Yeniden bağlanınca ekrandaki online rozetini sunucudaki güncel durumla eşitle
        this.refreshOwnOnlineStatus()
      })

      // Dinleyiciler connect içinde değil bir kez kaydediliyor;
      // her yeniden bağlanmada kopyalanıp gelen aramayı birden çok kez tetikliyordu
      _connection.on('appCallRequest', async (data, ack) => {
        const callType = data.type === 'APP_CALL_REQUEST' ? 'audio' : 'video'

        // if (callType === 'video' && !this.userCanReceiveVideoCall) {
        //   return
        // }

        ack('appCallRequestACK')

        this.nudityCheckIntervalInSecs = data?.agoraCall?.nudityCheckIntervalInSecs

        await this.$store.dispatch('agora/setCallRequestInfo', data)

        // Arayan bilgisi alınamazsa arama sessizce kaybolmasın: bir kez daha dene
        const showIncomingCall = async response => {
          await this.$store.dispatch('app/setModalCallType', callType)
          this.triggerShowAgoraCall(response.data.body, 'incoming')
        }
        useJwt.getUser(data.from)
          .catch(() => useJwt.getUser(data.from))
          .then(showIncomingCall)
          .catch(error => {
            console.warn('Gelen arama: arayan kullanıcı bilgisi alınamadı', error)
          })
      })

      _connection.on('notification', async data => {
        if (data.notificationType === 42) {
          // this.modalDownloadApp = true
          // this.streamStartedNotification = data.messageText
        }

        // if (data.title) {
        //   this.$toast({
        //     component: Notification,
        //     props: {
        //       data,
        //       router: this.$router,
        //       store: this.$store,
        //     },
        //   }, {
        //     position: 'top-right',
        //     closeButton: 'button',
        //     timeout: 10000,
        //     pauseOnHover: true,
        //     closeOnClick: false,
        //     hideProgressBar: false,
        //     pauseOnFocusLoss: true,
        //     draggable: false,
        //     draggablePercent: 0.6,
        //     showCloseButtonOnHover: true,
        //     rtl: false,
        //   })
        // }
      })

      _connection.on('giftReceived', data => {
        this.riveStatus = true

        const rivePath = `../assets/animations/${data.gift.riv}`

        setTimeout(() => {
          // eslint-disable-next-line no-new
          this.rive = new Rive({
            canvas: this.$refs.canvasRive,
            src: rivePath,
            autoplay: true,
            onStop: () => {
              this.riveStatus = false
            },
          })
        }, 111)
      })

      _connection.on('userStatusEvent', async data => {
        this.$store.dispatch('users/addUser', data)
      })

      _chatConnection.on('connect', () => {
        this.$store.dispatch('socket/updateConnecting', false)
        this.$store.dispatch('socket/updateConnected', true)
        this.reconnectCountChat = 0
      })

      _chatConnection.on('showModal', data => {
        if (data && typeof data.show !== 'undefined') { // Type is popup
          if (data.show === 'message_completed') { // Show is message_completed
            this.showModalData = data
            this.modalMessageCompleted = true
            this.modalNdcMessageFlow = false
            this.modalBoostFlow = false
          } else if (data.show === 'show_ndc_message_flow') { // Show is show_ndc_message_flow
            this.showModalData = data
            this.modalMessageCompleted = false
            this.modalNdcMessageFlow = true
            this.modalBoostFlow = false
          } else if (data.show === 'vip_user_popup') { // Show is vip_user_popup
            this.showModalData = data
            this.modalMessageCompleted = false
            this.modalNdcMessageFlow = false
            this.modalBoostFlow = true
          } else { // Show is other
            this.showModalData = null
            this.modalMessageCompleted = false
            this.modalNdcMessageFlow = false
            this.modalBoostFlow = false
          }
        }
      })
    },
    // eslint-disable-next-line consistent-return
    phoneNumberVerificationCode() {
      if (!this.valid) {
        this.$refs.phoneForm.setErrors({
          phone: this.$t('Check phone number'),
        })
        return false
      }
      this.$refs.phoneForm.validate().then(success => {
        if (success) {
          this.loading = true
          useJwt.phoneNumberVerification({ phoneNumber: this.phoneWithCountryCode })
            .then(response => {
              showNotify(this.$toast, response.data.body, 'success')
              this.verificationType = 'phone'
              this.modalPinCode = true
              this.modalAddPhoneNumber = false
            })
            .catch(error => {
              throwDefaultError(this.$toast, error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    phoneValidate(status) {
      this.valid = status ? status.valid : false
      this.$refs.phoneForm.reset()
    },
    sendAgainPinCode() {
      // eslint-disable-next-line no-empty
      if (this.verificationType === 'phone') {

        // eslint-disable-next-line no-empty
      } else if (this.verificationType === 'email') {

      }
    },
    triggerShowAgoraCall(user, callType = 'outgoing') {
      this.$store.dispatch('agora/setAgoraCallType', callType)
      this.$store.dispatch('agora/setAgoraCallUser', user)
      this.showAgoraCall = false
      this.showAgoraVideoCall = false

      if (this.modalCallType === 'audio') {
        setTimeout(() => {
          this.showAgoraCall = true
        }, 33)
      } else if (this.modalCallType === 'video') {
        setTimeout(() => {
          this.showAgoraVideoCall = true
        }, 33)
      }

      this.modalCall = false
    },
    triggerSippyCall() {
      if (!this.userPhoneNumber2) {
        this.modalAddPhoneNumberShowDiamond = false
        this.modalAddPhoneNumber = true
        this.verificationType = 'phone'
      } else {
        this.loading = true
        useJwt.callUser(this.modalCallUser.id || this.modalCallUser.userId)
          .then(() => {
            showNotify(this.toast, this.$t('Calling successful'), 'success')
          })
          .catch(error => {
            const { response } = error
            throwDefaultError(this.$toast, error)
            // eslint-disable-next-line eqeqeq
            if (response && response.data?.header?.error?.errorCode == 215) {
              store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
              store.dispatch('app/setModalAddPhoneNumber', true)
              store.dispatch('app/setVerificationType', 'phone')
            }
          })
          .finally(() => {
            this.loading = false
            this.modalCall = false
            this.modalCallSuggestion = false
          })
      }
    },
    userTriggeredFreeMessage() {
      if (this.showModalData) {
        this.loading = true
        useJwt.userTriggeredFreeMessage({ to_user_uuid: this.showModalData.uuid })
          .then(() => {
            showNotify(this.$toast, `${this.$t('Process successful')}. ${this.$t('You are being redirected')}...`, 'success')

            setTimeout(() => {
              this.$router.push({ name: 'chat', params: { userId: this.showModalData.uuid } })
              this.showModalData = null
            }, 2000)
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
            this.modalNdcMessageFlow = false
          })
      }
    },
    verification() {
      if (this.verificationType === 'phone') {
        this.loading = true
        const data = {
          phoneNumber: this.phoneWithCountryCode,
          pinCode: this.password,
          deviceId: this.$store.getters['app/deviceId'],
        }
        useJwt.phoneNumberUpdate(data)
          .then(response => {
            // eslint-disable-next-line no-underscore-dangle
            const _user = response.data.body
            if (_user.phoneNumber) {
              this.$store.dispatch('auth/updateUser', _user)
              showNotify(this.$toast, this.$t('Adding a phone number is successful'), 'success')
              this.modalAddPhoneNumber = false
              this.modalPinCode = false
              this.phone = ''
            } else {
              throwDefaultError(this.$toast)
            }
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
            this.password = ''
          })
      } else if (this.verificationType === 'email') {
        this.loading = true
        const data = {
          email: this.email,
          pinCode: this.password,
          deviceId: this.$store.getters['app/deviceId'],
        }
        useJwt.emailUpdate(data)
          .then(response => {
            // eslint-disable-next-line no-underscore-dangle
            const _user = response.data.body
            if (_user.email) {
              this.$store.dispatch('auth/updateUser', _user)
              showNotify(this.$toast, this.$t('Adding a email address is successful'), 'success')
              this.modalAddEmail = false
              this.modalPinCode = false
              this.email = ''
            } else {
              throwDefaultError(this.$toast)
            }
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
            this.password = ''
          })
      }
    },

    // Idle
    startInactivityTimer() {
      // Eğer modal açıksa timer başlatma
      if (this.modalIdle) return

      this.clearInactivityTimer()

      // Görüşme sırasında timer başlatma
      if (this.isInCall) return

      // Geri sayımın başladığı gerçek saat: mobilde sekme arka plandayken setTimeout dondurulduğu için
      // dönüşte süre buna göre kontrol edilir (bkz. checkInactivityOnReturn)
      this.inactivityStartedAt = Date.now()
      this.inactivityTimer = setTimeout(() => {
        this.handleInactivity()
      }, this.inactivityTimeout)
    },

    // Mobil (iOS Safari / Android Chrome) sekme arka plandayken zamanlayıcıları dondurur; dönüşte geçen süre
    // sayılmaz ve ilk dokunuş sayacı sıfırlar, bu yüzden "Burada mısın?" mobilde hiç çıkmıyordu.
    // Kural aynı (3 dk hareketsizlik -> pencere): sadece süre gerçek saate göre ölçülür. Pencere açıldıysa true döner.
    checkInactivityOnReturn() {
      if (!this.user || this.userGender !== 'female' || this.modalIdle || this.isInCall) return false
      if (!this.inactivityTimer || !this.inactivityStartedAt) return false
      if (Date.now() - this.inactivityStartedAt < this.inactivityTimeout) return false

      this.clearInactivityTimer()
      this.handleInactivity()
      return this.modalIdle
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer)
        this.inactivityTimer = null
      }
    },

    startSocketDisconnectTimer() {
      this.clearSocketDisconnectTimer()
      this.socketDisconnectTimer = setTimeout(() => {
        // 1 dakika sonra socket bağlantısını kes
        if (this.socketConnection && this.socketConnection.connected) {
          this.socketConnection.disconnect()
          console.log('1 dakika boyunca buton basılmadı - Socket bağlantısı kesildi')
        }
      }, this.socketDisconnectTimeout)
    },

    clearSocketDisconnectTimer() {
      if (this.socketDisconnectTimer) {
        clearTimeout(this.socketDisconnectTimer)
        this.socketDisconnectTimer = null
      }
    },

    resetInactivityTimer() {
      // Eğer modal açıksa timer reset etme
      if (this.modalIdle) return

      if (this.userGender === 'female') {
        this.startInactivityTimer()
        this.addEventListeners()
      }
    },

    // Sekmeye geri dönüldüğünde: arka planda tarayıcı zamanlayıcıları yavaşlattığı için socket.io (v2, ping'i
    // istemci gönderir) bağlantısı sunucu tarafından kopmuş olabilir ve yeniden bağlanma 10-30 sn bekliyordu.
    // Bağlantı kopmuşsa hemen yeniden bağlan. Hareketsizlik penceresi açıksa ("Burada mısın?") kurala dokunma.
    onPresenceVisibilityChange(event) {
      // pageshow her ilk açılışta da gelir; yalnızca önbellekten (bfcache) geri dönüşte işle
      if (event && event.type === 'pageshow' && !event.persisted) return
      if (document.hidden || !this.user || this.modalIdle) return

      // Arka planda 3 dk'dan uzun kalındıysa önce "Burada mısın?" penceresini aç (kural aynı);
      // bağlantı, kullanıcı "Buradayım"a basınca modalIdle izleyicisi tarafından kurulur
      if (this.checkInactivityOnReturn()) return

      this.reconnectSocketsNow()
      this.verifyPresenceOnReturn()
    },

    // Mobilde site arka plandayken telefon sayfayı donduruyor; sunucu ping alamayınca bağlantıyı kapatıp kullanıcıyı
    // offline yapıyor. Dönüşte socket.io (v2) bağlantının öldüğünü ancak bir sonraki ping zaman aşımında anlıyor,
    // o zamana kadar connected=true sanıyor ve reconnectSocketsNow hiçbir şey yapmıyordu: kullanıcı gri kalıyordu
    // (sayfa yenilenince düzeliyordu). Dönüşte durumu sunucuya sor; sunucu offline diyorsa socket'i hemen yeniden kur
    // (sayfa yenilemenin yaptığının aynısı). Görüşme sırasında yapılmaz (kesmek görüşmeyi düşürebilir).
    verifyPresenceOnReturn() {
      if (!this.user || this.modalIdle || this.isInCall) return
      useJwt.getMe()
        .then(response => {
          const profile = response && response.data && response.data.body && response.data.body.profile
          const status = profile ? profile.onlineStatus : null
          if (!status) return
          this.$store.dispatch('auth/setUserOnlineStatus', status)
          if (status !== 'offline' || document.hidden || this.modalIdle || this.isInCall) return

          const connections = [this.$store.getters['socket/connection'], this.$store.getters['socket/chatConnection']]
          connections.forEach(connection => {
            if (!connection || typeof connection.connect !== 'function') return
            // connected=true olsa bile bağlantı ölü olabilir: kapat ve hemen yeniden bağlan
            if (connection.connected) connection.disconnect()
            else if (connection.io && connection.io.reconnecting && typeof connection.io.disconnect === 'function') connection.io.disconnect()
            connection.connect()
          })
          this.reconnectCount = 0
          this.reconnectCountChat = 0
        })
        .catch(() => {})
    },

    // Kopmuş ana ve sohbet socket'ini hemen yeniden bağlar (sekmeye dönüş ve "Buradayım" ortak kullanır)
    reconnectSocketsNow() {
      const connections = [this.$store.getters['socket/connection'], this.$store.getters['socket/chatConnection']]
      connections.forEach(connection => {
        if (connection && !connection.connected && typeof connection.connect === 'function') {
          // socket.io v2: yeniden bağlanma beklemesindeyken (io.reconnecting) connect() hiçbir şey yapmıyor ve
          // 5-15 sn'lik bekleme sayacını bekliyordu (test: 6.8 sn). Bekleyen denemeyi iptal edip hemen bağlan.
          if (connection.io && connection.io.reconnecting && typeof connection.io.disconnect === 'function') {
            connection.io.disconnect()
          }
          connection.connect()
        }
      })
      this.reconnectCount = 0
      this.reconnectCountChat = 0
    },

    // Socket bağlanınca sunucu kullanıcıyı online yapıyor ama ekrandaki yeşil/gri rozet (store'daki
    // profile.onlineStatus) yenilenmiyordu; sayfa yenilenene kadar gri kalıyordu. Bağlantı kurulunca güncel
    // durumu sunucudan okuyup rozeti günceller.
    refreshOwnOnlineStatus() {
      if (!this.user) return
      useJwt.getMe()
        .then(response => {
          const status = response && response.data && response.data.body && response.data.body.profile
            ? response.data.body.profile.onlineStatus
            : null
          if (status) this.$store.dispatch('auth/setUserOnlineStatus', status)
        })
        .catch(() => {})
    },

    setupPresenceRecovery() {
      document.addEventListener('visibilitychange', this.onPresenceVisibilityChange)
      // iOS Safari sayfayı önbellekten (bfcache) geri getirince visibilitychange yerine pageshow gelebilir
      window.addEventListener('pageshow', this.onPresenceVisibilityChange)
    },

    handleInactivity() {
      // Görüşme sırasında popup açma
      if (this.isInCall) return

      // 60 saniye hareketsizlik sonrası modalIdle'ı true yap
      this.modalIdle = true
      console.log('Kullanıcı 60 saniye hareketsiz - Modal açıldı!')
    },

    addEventListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
      events.forEach(event => {
        document.addEventListener(event, this.resetInactivityTimer, true)
      })
    },

    removeEventListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
      events.forEach(event => {
        document.removeEventListener(event, this.resetInactivityTimer, true)
      })
    },
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    const modalDownloadMobileApp = computed({
      get: () => store.getters['app/modalDownloadMobileApp'],
      set: val => {
        store.dispatch('app/setModalDownloadMobileApp', val)
      },
    })

    const oopsModalText = computed(() => store.getters['app/oopsModalText'])
    const oopsModal = computed({
      get: () => store.getters['app/oopsModal'],
      set: val => {
        store.dispatch('app/setOopsModal', val)
      },
    })

    const paymentCraftgate = computed(() => store.getters['payment/paymentCraftgate'])
    const paymentHtml = computed(() => store.getters['payment/paymentHtml'])
    const paymentData = computed({
      get: () => store.getters['payment/paymentData'],
      set: val => {
        store.dispatch('payment/setPaymentData', val)
      },
    })
    const paymentStatus = computed({
      get: () => store.getters['payment/status'],
      set: val => {
        store.dispatch('payment/setStatus', val)
      },
    })

    const showAgoraCall = computed({
      get: () => store.getters['agora/showAgoraCall'],
      set: val => {
        store.dispatch('agora/setShowAgoraCall', val)
      },
    })

    const showAgoraVideoCall = computed({
      get: () => store.getters['agora/showAgoraVideoCall'],
      set: val => {
        store.dispatch('agora/setShowAgoraVideoCall', val)
      },
    })

    const modalCallSuggestion = computed({
      get: () => store.getters['app/modalCallSuggestion'],
      set: val => {
        store.dispatch('app/setModalCallSuggestion', val)
      },
    })

    const loading = ref(false)

    const modalAddPhoneNumber = computed({
      get: () => store.getters['app/modalAddPhoneNumber'],
      set: val => {
        store.dispatch('app/setModalAddPhoneNumber', val)
      },
    })
    const modalAddPhoneNumberShowDiamond = computed({
      get: () => store.getters['app/modalAddPhoneNumberShowDiamond'],
      set: val => {
        store.dispatch('app/setModalAddPhoneNumberShowDiamond', val)
      },
    })

    const modalAddEmail = computed({
      get: () => store.getters['app/modalAddEmail'],
      set: val => {
        store.dispatch('app/setModalAddEmail', val)
      },
    })

    const modalPinCode = computed({
      get: () => store.getters['app/modalPinCode'],
      set: val => {
        store.dispatch('app/setModalPinCode', val)
      },
    })

    const verificationType = computed({
      get: () => store.getters['app/verificationType'],
      set: val => {
        store.dispatch('app/setVerificationType', val)
      },
    })

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    const closeModal = () => {
      store.dispatch('app/setModalDownloadMobileApp', false)
    }

    /**
     * Kullanıcının telefon numarası yoksa eklemesi için telefon numarası ekleme modal'ını göster
     */
    const user = computed(() => store.getters['auth/user'])
    const userPhoneNumber = computed(() => store.getters['auth/userPhoneNumber'])
    if (user.value && !userPhoneNumber.value) {
      // modalAddPhoneNumberShowDiamond.value = true
      // modalAddPhoneNumber.value = true
      // verificationType.value = 'phone'
    }
    watch(userPhoneNumber, val => {
      if (user.value && !val) {
        // modalAddPhoneNumberShowDiamond.value = true
        // modalAddPhoneNumber.value = true
        // verificationType.value = 'phone'
      }
    })

    /**
     * Kullanıcının emaili yoksa eklemesi için telefon numarası ekleme modal'ını göster
     */
    const userEmail = computed(() => store.getters['auth/userEmail'])

    const checkModalAddEmailShowed = () => {
      const modalAddEmailShowedTime = localStorage.getItem('modalAddEmailShowedTime')
      if (modalAddEmailShowedTime) {
        const now = new Date().getTime()
        // eslint-disable-next-line radix
        const diff = now - parseInt(modalAddEmailShowedTime)
        if (diff < 1000 * 60 * 60 * 24 * 1) { // 1 gün
          return true
        }
      }

      return false
    }

    if (user.value && !userEmail.value && !checkModalAddEmailShowed()) {
      modalAddEmail.value = true
      verificationType.value = 'email'
      localStorage.setItem('modalAddEmailShowedTime', new Date().getTime())
    }

    watch(userEmail, val => {
      if (user.value && !val && !checkModalAddEmailShowed()) {
        modalAddEmail.value = true
        verificationType.value = 'email'
        localStorage.setItem('modalAddEmailShowedTime', new Date().getTime())
      }
    })

    const checkVersion = () => {
      axios.get('/v.json')
        .then(response => {
          try {
            // eslint-disable-next-line radix
            const version = parseInt(response.data.v.replaceAll('.', ''))
            let currentVersion = localStorage.getItem('version') || '1.0.0'
            // eslint-disable-next-line radix
            currentVersion = parseInt(currentVersion.replaceAll('.', ''))

            localStorage.setItem('version', response.data.v)

            if (currentVersion !== 100 && currentVersion < version) {
              window.location.reload()
            }
          } catch (e) {
            console.log('e', e)
          }
        })
    }
    setInterval(() => {
      checkVersion()
    }, 60 * 1000)

    return {
      badgeAppleStore,
      badgeAppleStore2,
      badgeGooglePlay,
      badgeGooglePlay2,
      closeModal,
      email: ref(''),
      enableScrollToTop,
      iconDiamond2,
      imageCreditsOops,
      imageCreditsOopsSadFace,
      loading,
      modalCallSuggestion,
      modalAddEmail,
      modalAddPhoneNumber,
      modalAddPhoneNumberShowDiamond,
      modalDownloadMobileApp,
      modalPinCode,
      oopsModal,
      oopsModalText,
      paymentData,
      paymentCraftgate,
      paymentHtml,
      paymentStatus,
      qrCodeImage,
      showAgoraCall,
      showAgoraVideoCall,
      skinClasses,
      user,
      verificationType,
    }
  },
}
</script>

<style lang="scss" scoped>
.password-information {
  font-family: 'Lexend', sans-serif;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    color: #000000;
    text-align: center;
  }

  p {
    font-family: inherit;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    color: #8893A4;
  }

  .send-again {
    margin-top: 14px;
    font-family: inherit;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    color: #8893A4;

    .link {
      cursor: pointer;
      color: #F9447A;
    }
  }
}

.credits-oops {
  .credits-oops-image {
    position: relative;

    .credit-oops-image-text {
      color: #fff;
      font-family: 'Lexend', sans-serif;
      font-size: 32px;
      font-weight: bold;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      text-transform: uppercase;
    }
  }
}

#canvas-rive-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Paywall Blocker with Blur Effect */
#app:has(.paywall):after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>

<style lang="scss">
.min-h-100 {
  min-height: 100% !important;
}

div.vue-pincode-input-wrapper {
  .vue-pincode-input {
    margin: 0 8px;
    padding: 5px;
    text-align: center;
    border: none;
    box-shadow: 0 0 2px rgb(0 0 0 / 50%);
    border-radius: 12px;
    font-family: 'Lexend', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 35px;
    color: #000000;

    &:focus {
      box-shadow: none;
      border: 2px solid #000;
    }
  }
}

#app {
  margin-top: 0 !important;
  background-color: #11172b !important;
  background-image: linear-gradient(
    0deg,
    rgba(234, 3, 178, 0.22) 0%,
    rgba(234, 3, 178, 0.12) 20%,
    rgba(234, 3, 178, 0.04) 45%,
    rgba(17, 23, 43, 0) 70%
  ) !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
  min-height: 100vh;
}

.boho-dark-layout-2 {
  background-color: #11172b !important;
  background-image: linear-gradient(
    0deg,
    rgba(234, 3, 178, 0.22) 0%,
    rgba(234, 3, 178, 0.12) 20%,
    rgba(234, 3, 178, 0.04) 45%,
    rgba(17, 23, 43, 0) 70%
  ) !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;

  .navbar-container {
    background-color: #11172b !important;
  }

  .navbar-light, .main-menu.menu-light, .main-menu.menu-light .navigation,
  .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,
  [dir] .main-menu.menu-light .navigation > li.sidebar-group-active > a {
    background-color: transparent !important;
  }

  .main-menu.menu-light .navigation li a,
  .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after,
  .market-link, .navbar-nav > a, .navbar-nav > li > a, .navbar-nav svg.text-body {
    color: #fff !important;
  }

  .main-menu.menu-shadow {
    box-shadow: 0 0 2px 1px rgba(241, 183, 234, 0.75) !important;
  }

  .main-menu {
    background: #200423 !important;
  }
}

.tasks-dark-layout {
  background: linear-gradient(180deg, #0f1628 0%, #1a1f3a 50%, #0d1321 100%) !important;

  .navbar-container {
    background-color: #141b2d !important;
  }

  .navbar-light, .main-menu.menu-light, .main-menu.menu-light .navigation,
  .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a,
  [dir] .main-menu.menu-light .navigation > li.sidebar-group-active > a {
    background-color: transparent !important;
  }

  .main-menu.menu-light .navigation li a,
  .vertical-layout.vertical-menu-modern.menu-expanded .main-menu .navigation li.has-sub > a:after,
  .market-link, .navbar-nav > a, .navbar-nav > li > a, .navbar-nav svg.text-body {
    color: #fff !important;
  }

  .main-menu.menu-shadow {
    box-shadow: 0 0 2px 1px rgba(59, 130, 246, 0.3) !important;
  }

  .main-menu {
    background: #0f1628 !important;
  }
}
</style>
